import React from "react";
import { infoBoxStyle } from "../../styles/commonStyles";

export default function InfoMessage({ message }) {
  if (!message) return null;
  return <div style={infoBoxStyle()}>{message}</div>;
}